(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rs-camera-pack-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rs-camera-pack-selector')) {
  customElements.define('rs-camera-pack-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        const form = this.closest('.product-section__product-info')?.querySelector('product-form form');
        const quantity = form?.querySelector('input[name="quantity"]');
        if (!quantity) return;
        quantity.value = event.target.value;
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    getDiscount(quantity) {
      if (this.dataset.promotionActive !== 'true') return 0;
      if (quantity === 2) return Number(this.dataset.duoSaving) || 0;
      if (quantity === 3) return Number(this.dataset.trioSaving) || 0;
      return 0;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rs-camera-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rs-camera-promo')) {
    customElements.define('rs-camera-promo', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        if (!button || !status) return;
        button.addEventListener('click', async () => {
          const code = button.dataset.code;
          let copied = false;
          if (navigator.clipboard?.writeText) {
            try { await navigator.clipboard.writeText(code); copied = true; } catch {}
          }
          if (!copied) {
            const input = document.createElement('textarea');
            input.value = code;
            input.readOnly = true;
            input.style.cssText = 'position:fixed;top:-1000px;left:-1000px;';
            document.body.append(input);
            input.select();
            try { copied = document.execCommand('copy'); } catch {}
            input.remove();
            button.focus();
          }
          status.textContent = copied ? button.dataset.copied : `${button.dataset.failed} ${code}`;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
